module.exports = __webpack_public_path__ + "img/材料力学5_12_3.50db8f4d.jpg";